import { getOthBesluitType } from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';

// Data is not expected to change, so it can be cached for a long time
const STALE_TIME = Infinity;

export const useBesluitType = createQuery({
  key: ['besluitType'],
  queryFn: () => getOthBesluitType(),
  defaultOptions: {
    staleTime: STALE_TIME,
  },
});

export const useBesluitTypeId = createQuery({
  key: ['besluitTypeId'],
  queryFn: async (id: string) => {
    const besluitTypes = await useBesluitType.ensureQueryData({});

    const besluitType = besluitTypes.find(
      (besluitType) => besluitType.ID === id
    );

    if (!besluitType) {
      throw new Error('Besluit type not found');
    }

    return besluitType;
  },
  defaultOptions: {
    staleTime: STALE_TIME,
  },
});
